module.exports = __webpack_public_path__ + "img/icon-bell.e09eb743.svg";